import React from "react";

const NoMatchPage = () => {
    return <div>페이지가 없습니다</div>;
};

export default NoMatchPage;
